import { isLocalhost } from "@/lib/debug/debug";
import { useLanguage } from "@/lib/i18n/LanguageContext";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";

function HomePage() {
  const { t } = useLanguage();

  return (
    <div className="home-container flex flex-col items-center justify-center flex-1 p-4">
      <div className="home-content text-center space-y-6 sm:space-y-8 w-full max-w-sm sm:max-w-md">
        <p className="home-description text-base sm:text-lg text-gray-600 dark:text-gray-400 px-2">
          {t("homeDescription")}
        </p>
        <div className="home-navigation space-y-3 sm:space-y-4 px-4 sm:px-0">
          <div className="nav-item-cotd">
            <Link to="/cotd">
              <Button
                variant="outline"
                className="btn-cotd w-full sm:w-48 h-12 text-base sm:text-lg border-2 border-black dark:border-gray-600 hover:bg-black hover:text-white dark:hover:bg-gray-700 transition-colors"
              >
                {t("cardOfTheDay")}
              </Button>
            </Link>
          </div>
          {isLocalhost() && (
            <div className="nav-item-demo">
              <Link to="/demo">
                <Button
                  variant="outline"
                  className="btn-demo w-full sm:w-48 h-12 text-base sm:text-lg border-2 border-black dark:border-gray-600 hover:bg-black hover:text-white dark:hover:bg-gray-700 transition-colors"
                >
                  {t("demoPage")}
                </Button>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default HomePage;
